import { proxyCustomElement, HTMLElement, createEvent, h, Host } from '@stencil/core/internal/client';
import { d as defineCustomElement$2 } from './form-control-error-text2.js';
import { d as defineCustomElement$1 } from './form-control-help-text2.js';

const CheckboxInput = /*@__PURE__*/ proxyCustomElement(class CheckboxInput extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.formControlInput = createEvent(this, "formControlInput", 7);
        this.formControlBlur = createEvent(this, "formControlBlur", 7);
        this.handleFormControlInput = (event) => {
            const target = event.target;
            const name = target.getAttribute('name');
            this.inputHandler(name, target.checked);
            this.formControlInput.emit({ name, value: target.value });
        };
        this.updateInput = (newValue) => {
            this.checkboxElement.checked = newValue;
        };
        this.label = undefined;
        this.name = undefined;
        this.helpText = undefined;
        this.errorText = undefined;
        this.defaultValue = undefined;
        this.inputHandler = undefined;
        this.disabled = undefined;
    }
    handleDefaultValueChange(newValue) {
        this.updateInput(newValue);
    }
    componentDidLoad() {
        this.updateInput(this.defaultValue);
    }
    render() {
        return (h(Host, { key: '62c7e5756a185d29a941dd63a431756beed3d554', exportparts: "label,input,input-invalid" }, h("div", { key: 'db89c096aa07aecd8c5205905c26f56ac4282a3a', class: 'form-group d-flex flex-column' }, h("div", { key: '8f6c06c0150eee6284d3b2465b3aca916c2d7f83', class: "form-check" }, h("input", { key: '25b9b0a620ee3fce0f4fa4892a38b289e0a0d521', ref: el => (this.checkboxElement = el), type: "checkbox", id: this.name, name: this.name, onBlur: this.formControlBlur.emit, onInput: this.handleFormControlInput, part: `input-checkbox ${this.errorText ? 'input-checkbox-invalid' : ''}`, class: this.errorText ? 'form-check-input is-invalid' : 'form-check-input', disabled: this.disabled }), h("label", { key: '783d5dbbafeeeceab3400361eff65cd6a075f637', class: "form-check-label", htmlFor: this.name }, this.label)), h("form-control-help-text", { key: '4b129fa8360d7d305f14939d213667a9003c6b94', helpText: this.helpText, name: this.name }), h("form-control-error-text", { key: '303b12a3b51634866a4266486ac6295f5d582ab6', errorText: this.errorText, name: this.name }))));
    }
    static get watchers() { return {
        "defaultValue": ["handleDefaultValueChange"]
    }; }
}, [0, "form-control-checkbox", {
        "label": [1],
        "name": [8],
        "helpText": [1, "help-text"],
        "errorText": [1, "error-text"],
        "defaultValue": [4, "default-value"],
        "inputHandler": [16],
        "disabled": [4]
    }, undefined, {
        "defaultValue": ["handleDefaultValueChange"]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["form-control-checkbox", "form-control-error-text", "form-control-help-text"];
    components.forEach(tagName => { switch (tagName) {
        case "form-control-checkbox":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CheckboxInput);
            }
            break;
        case "form-control-error-text":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
        case "form-control-help-text":
            if (!customElements.get(tagName)) {
                defineCustomElement$1();
            }
            break;
    } });
}
defineCustomElement();

export { CheckboxInput as C, defineCustomElement as d };
